import Drupal from 'Drupal';
import $ from 'jquery';
import Accordion from 'js/components/Accordion';

Drupal.behaviors.imageCards = {
  attach: (context) => {
    context.querySelectorAll('.image-card').forEach((element) => {
      if (!element.Accordion) {
        element.Accordion = new Accordion(element, {
          activeClass: `image-card--expanded`,
          toggleSelector: `.image-card__toggle`,
          contentSelector: `.image-card__content`,
        });

        $(element.Accordion.element).on('mouseenter', function () {
          $(this).addClass('image-card--expanded');
        });
        $(element.Accordion.element).on('mouseleave', function () {
          $(this).removeClass('image-card--expanded');
        });
      }
    });
  },
};
